import { Component, Input, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AppService } from "../../../../core/services/app.service";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: "app-rename-popup",
  templateUrl: "./rename-popup.component.html",
})
export class RenamePopupComponent implements OnInit {
  @Input() model;
  @Input() digitalLogId: string;
  @Input() currentName: string;
  
  // Add property to track input value
  inputValue: string = '';

  public static renameAPI = AppService.getApiUrl() + "/api/digitalMemoryLogs/";

  constructor(
    public activeModal: NgbActiveModal,
    private toastr: ToastrService,
    protected http: HttpClient
  ) {}

  ngOnInit() {
    // Set current name as default value
    if (this.currentName) {
      this.model = { ...this.model, name: this.currentName };
      this.inputValue = this.currentName; // Set initial value for character count
    }
  }

  // Manual close method
  closeModal() {
    try {
      this.activeModal.close();
    } catch (error) {
      this.activeModal.dismiss();
    }
  }

  public renameDigitalLog(data) {
    if (!this.inputValue || this.inputValue.trim() === "") {
      this.toastr.error("Name is required", "Error");
      return;
    }

    this.http
      .put(RenamePopupComponent.renameAPI + this.digitalLogId, {
        name: this.inputValue.trim(),
      })
      .subscribe(
        (res: any) => {
          this.toastr.success(
            "Digital Memory Log renamed successfully!",
            "Success"
          );

          // Close modal with a small delay to ensure toast is shown
          setTimeout(() => {
            this.closeModal();
          }, 100);
        },
        (error) => {
          this.toastr.error(
            error
              ? error.error.Message || "Failed to rename digital memory log"
              : "",
            "Error"
          );
        }
      );
  }
}
